export const I18N_STORAGE_KEY = 'mp_install_portal.lang';

export const AVAILABLE_LANGS = ['en-US', 'zh-CN'] as const;

export type AppLanguage = (typeof AVAILABLE_LANGS)[number];
